/**
 * Helper to check if a value is truly empty.
 * Handles undefined, null, empty strings, and their string representations from API.
 * Also detects formatted addresses like "undefined, , , , " or "null, , , , ".
 *
 * @param value - The value to check
 * @returns true if the value is empty or contains only "undefined"/"null" with commas/spaces
 *
 * @example
 * isEmptyValue(undefined) // true
 * isEmptyValue(null) // true
 * isEmptyValue('') // true
 * isEmptyValue('undefined') // true
 * isEmptyValue('null') // true
 * isEmptyValue('undefined, , , , ') // true
 * isEmptyValue('123 Main St') // false
 */
export const isEmptyValue = (value: any): boolean => {
  if (!value || value === 'undefined' || value === 'null' || value === '') {
    return true;
  }
  // Check for formatted addresses like "undefined, , , , " or "null, , , , "
  const cleanedValue = String(value).replace(/undefined|null|,|\s/g, '').trim();
  return cleanedValue === '';
};
